<div style="width: auto; overflow: auto">
  <app-common-list-table
    [request]="getRequest"
    [cols]="cols"
    [filtering]="filter"
    [actionButtonText]="env.canAddFincas ? 'Añadir ' + env.fincaName : ''"
    (actionButtonClick)="add()"
    [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform"
    [customExportCsv]="env.showFincasCsv"
    (visualize)="show('info', $event)"
    (edit)="edit($event)"
    (remove)="show('delete', $event)">

    <!-- Header slot -->
    <!-- HEADER EXTRA -->
<ng-template #thEnd>
  @if (env.showCuadernoDeCampo) {
    <th class="rt-icon-col">
      <p class="d-flex justify-content-center mb-0">
        {{ env.appName === 'donjardin' ? 'Registro Transacciones' : 'Cuaderno' }}
      </p>
    </th>
  }

  <!-- ——— Acciones con ancho fijo ——— -->
  <th class="rt-actions-col">
    <p class="d-flex justify-content-center mb-0">Acciones</p>
  </th>

  @if (env.showCargaPAC) {
    <th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">PAC</p></th>
  }
  @if (env.showFincasGenGml) {
    <th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">GML</p></th>
  }
  @if (env.activateREA) {
    <th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">REA</p></th>
    <th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">CUE</p></th>
  }
</ng-template>

<!-- BODY EXTRA -->
<ng-template #tdEnd let-data>
  @if (env.showCuadernoDeCampo) {
    <td class="rt-icon-col">
      <div class="d-flex justify-content-center">
        <button (click)="show('generate', data); filterSectores()"
                class="d-flex justify-content-center align-items-center"
                style="height: 20px; width: 85px; border: none; border-radius: 3px; background-color: #345fdc; color: white; cursor: pointer;">
          <i class="fa fa-book"></i><span>&nbsp;Generar</span>
        </button>
      </div>
    </td>
  }

  <!-- ——— Acciones con mismo ancho que el TH ——— -->
  <td class="rt-actions-col">
    <app-action-buttons
      [hideEdit]="!env.canEditFincas"
      [hideDelete]="!env.canDeleteFincas"
      [showDuplicate]="env.canDuplicateFinca"
      (duplicateRowButtonEvent)="duplicate(data.data)"
      (editRowButtonEvent)="edit(data.data)"
      (deleteRowButtonEvent)="show('delete', data.data)"
      (showRowButtonEvent)="show('info', data.data)">
    </app-action-buttons>
  </td>

  @if (env.showCargaPAC) {
    <td class="rt-icon-col">
      <div class="d-flex justify-content-center">
        <button class="d-flex justify-content-center align-items-center"
                (click)="uploadDialog(data.data)"
                style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #28a645; color: white">
          <i class="fa fa-upload"></i>
        </button>
      </div>
    </td>
  }

  @if (env.showFincasGenGml) {
    <td class="rt-icon-col">
      <div class="d-flex justify-content-center">
        <button class="d-flex justify-content-center align-items-center"
                (click)="generaGML(data.data)"
                style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #2863a6; color: white">
          <i class="fa fa-download"></i>
        </button>
      </div>
    </td>
  }

  @if (env.activateREA) {
    <td class="rt-icon-col">
      <div class="d-flex justify-content-center">
        <button class="d-flex justify-content-center align-items-center"
                (click)="show('importREA', data.data)"
                style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #2863a6; color: white">
          <i class="fa fa-download"></i>
        </button>
      </div>
    </td>

    <td class="rt-icon-col">
      <div class="d-flex justify-content-center">
        <button [pTooltip]="tooltipContent"
                class="d-flex justify-content-center align-items-center"
                (click)="show('sendCUE', data.data)"
                style="height: 20px; width: 45px; border-radius: 3px; border: none; background-color: #2863a6; color: white">
          <i class="fa"
             [ngClass]="{
               'fa-upload': !['en_proceso','no_proceso'].includes(data.data?.estado_cue),
               'fa-spinner fa-spin': data.data?.estado_cue === 'en_proceso',
               'fa-times': data.data?.estado_cue === 'no_proceso'
             }"></i>
        </button>
        <ng-template #tooltipContent>…</ng-template>
      </div>
    </td>
  }
</ng-template>
  </app-common-list-table>
</div>

<!-- Shared modals host -->
<app-modals
  [view]="this"
  [form]="form?.formFields"
  [serverUrl]="env.serverUrl"
  [previousData]="model"
  [recordHasAssociatedData]="true"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest">
</app-modals>

<p-dialog width="600"
          header="Importar datos PAC"
          [closeOnEscape]="false"
          [closable]="false"
          [(visible)]="showModalPAC"
          (onShow)="scrollToTop()">
  @if (showModalPAC) {
    <div style="width: 36vw !important">
      <p-fileUpload
        name="myfile[]"
        [disabled]="!enableUpload"
        [multiple]="false"
        [showCancelButton]="false"
        chooseLabel="Seleccionar archivo"
        uploadLabel="Enviar"
        [url]="urlUpload"
        (onSelect)="checkFile($event)"
        (onUpload)="uploaded($event)">
      </p-fileUpload>

      @if (showPACError) {
        <br />
        <p style="max-width: 400px; text-align: center; color: red" [innerHTML]="txtPACError"></p>
        <p style="max-width: 400px; text-align: center; color: green" [innerHTML]="txtPACInfo"></p>
      }

      <br />
      <div class="d-flex justify-content-center">
        <button class="btn btn-dark mx-2" (click)="closeFUDialog()">Cerrar</button>
      </div>
      <br />
    </div>
  }
</p-dialog>

 <p-dialog
  [visible]="canShow['importREA'] ?? false"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="false"
  [breakpoints]="{ '1199px': '60vw', '768px': '80vw', '575px': '92vw' }"
  [style]="{ width: '46vw' }"
  styleClass="rea-dialog"
  id="export-rea-dialog"
>
  <!-- ===== Custom header ===== -->
  <ng-template pTemplate="header">
    <div class="rea-header">
      <div class="rea-header__title">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>Importar REA</span>
      </div>

      <!-- Last import badge (informational) -->
      <p-tag
        *ngIf="historicoREA?.statusCode === 200"
        [value]="'Última Importación: ' + (historicoREA?.data?.fecha ?? '')"
        severity="info"
        [rounded]="true"
        class="rea-badge"
      ></p-tag>
      <p-tag
        *ngIf="historicoREA?.statusCode === 201"
        value="Nueva importación"
        severity="success"
        [rounded]="true"
        class="rea-badge"
      ></p-tag>
    </div>
  </ng-template>

  <!-- ===== Body ===== -->
  <div class="rea-body">
    <p-card class="rea-card">
      <!-- Meta data row -->
      <div class="grid rea-row">
        <div class="col-12 md:col-6">
          <label class="rea-label">Código REA</label>
          <p class="rea-value">{{ model.codigo_REA }}</p>
        </div>
        <div class="col-12 md:col-6">
          <label class="rea-label">NIF</label>
          <p class="rea-value">{{ model.titular_nif }}</p>
        </div>
      </div>

      <!-- Spinner overlay while processing -->
      <div class="rea-spinner" *ngIf="showSpinner">
        <p-progress-spinner strokeWidth="6" animationDuration="1.2s"></p-progress-spinner>
      </div>

      <!-- Detail card when backend returns breakdown -->
      <div class="rea-row" *ngIf="importResult?.statusCode === 202">
        <p-card>
          <h4 class="mb-2">Detalle de importación</h4>
          <div class="grid">
            <div class="col-12 md:col-6"><p>Parcelas no insertadas: <b>{{ importResult?.data.parcelasNoInsertadas }}</b></p></div>
            <div class="col-12 md:col-6"><p>Parcelas insertadas: <b>{{ importResult?.data.parcelasInsertadas }}</b></p></div>
            <div class="col-12 md:col-6"><p>Parcelas no actualizadas: <b>{{ importResult?.data.parcelasNoActualizadas }}</b></p></div>
            <div class="col-12 md:col-6"><p>Parcelas actualizadas: <b>{{ importResult?.data.parcelasActualizadas }}</b></p></div>
          </div>
        </p-card>
      </div>

      <!-- Messages (use p-message, not deprecated p-messages) -->
      <div class="rea-row">
        <p-message *ngIf="messageState === 'warning'"    severity="warn"    text="Falta datos para exportar REA"></p-message>
        <p-message *ngIf="messageState === 'error'"   severity="error"   [text]="importResult?.statusMessage"></p-message>
        <p-message *ngIf="messageState === 'success'" severity="success" [text]="importResult?.statusMessage"></p-message>
      </div>
    </p-card>
  </div>

  <!-- ===== Footer ===== -->
  <ng-template pTemplate="footer">
    <div class="d-flex w-100 justify-content-center align-items-center gap-5">
      <p-button
        *ngIf="importResult?.statusCode; else cancelBtn"
        label="Volver"
        severity="secondary"
        [fluid]="true"
        (onClick)="hide('importREA'); showSpinner = false; messageState = ''">
      </p-button>

      <ng-template #cancelBtn>
        <p-button
          label="Cancelar"
          type="button"
          label="Cancelar"
          severity="secondary"
          [fluid]="true"
          (onClick)="hide('importREA'); showSpinner = false; messageState = ''">
        </p-button>
      </ng-template>

      <p-button
        type="button"
        label="Enviar"
        [loading]="showSpinner"
        severity="success"
        [fluid]="true"
        (onClick)="showSpinner = true; exportREA(model)">
      </p-button>
    </div>
  </ng-template>
</p-dialog>



<p-dialog
  [visible]="canShow['sendCUE'] ?? false"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="false"
  [breakpoints]="{ '1199px': '60vw', '768px': '80vw', '575px': '92vw' }"
  [style]="{ width: '42vw' }"
  styleClass="cue-dialog"
  id="export-cue-dialog"
>
  <!-- ===== Custom header with status badge ===== -->
  <ng-template pTemplate="header">
    <div class="cue-header">
      <div class="cue-header__title">
        <i class="pi pi-upload" aria-hidden="true"></i>
        <span>Enviar CUE</span>
      </div>
 
      <p-tag
        [value]="'Última Importación: ' + ((statusCue?.fecha | date: 'dd/MM/yyyy') ?? 'Ninguna')"
        [severity]="'info'"
        class="cue-badge"
        [rounded]="true"
        [pTooltip]="statusHelp(statusCue?.estado)"
        tooltipPosition="bottom"
      ></p-tag>
    </div>
  </ng-template>

  <!-- ===== Body ===== -->
  <div class="cue-body">
    <p-card class="cue-card">
      <div class="cue-row">
        <div class="cue-meta">
          <p>Tareas Fitosanitarias no enviadas: <b>{{ counter?.fito }}</b></p>
          <p>Tareas Fertilizantes no enviadas: <b>{{ counter?.ferti }}</b></p>
        </div>
      </div>

      <p class="muted">Se procederá con el envío de los tratamientos.</p>

      <!-- Spinner overlay -->
      @if (showSpinner) {
        <div class="cue-spinner">
          <p-progress-spinner strokeWidth="6" animationDuration="1.2s"></p-progress-spinner>
        </div>
      }

      <!-- Message block -->
      @if (messageState) {
        <ng-container>
          <p-message
            [severity]="messageState"
            [text]="importResult?.statusMessage"
            styleClass="mb-3"
          ></p-message>
        </ng-container>


        <p class="pre-wrap">{{ importResult?.data[0]?.body }}</p>
      }
    </p-card>
  </div>

  <!-- ===== Footer ===== -->
  <ng-template pTemplate="footer">
    <div class="d-flex w-100 justify-content-center align-items-center gap-5">
      @if (importResult?.statusCode) {
        <p-button
          type="button"
          label="Volver"
          severity="secondary"
          [fluid]="true"
          (onClick)="hide('sendCUE'); showSpinner = false; messageState = ''"
        ></p-button>
      } @else {
        <p-button
          type="button"
          label="Cancelar"
          severity="secondary"
          [fluid]="true"
          (onClick)="hide('sendCUE'); showSpinner = false; messageState = ''"
        ></p-button>
      }

      <p-button
        type="button"
        label="Enviar"
        [loading]="showSpinner"
        severity="success"
        [fluid]="true"
        (onClick)="showSpinner = true; exportCUE(model)"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

